import { jsx as _jsx } from "react/jsx-runtime";
import { Paper } from "@mui/material";
import { MuiMarkdown_V2 } from "../Shared/components/MuiMarkdown/MuiMarkdown_V2";
export const LocationContentArea = ({ contentArea }) => (_jsx(Paper, Object.assign({ sx: {
        padding: 2,
    } }, { children: _jsx(MuiMarkdown_V2, { children: contentArea }) })));
